export const TOP_BAR_ICON_CLASSES =
  'inline-flex size-10 items-center justify-center rounded-full transition-colors hover:bg-community-text-on-bg/10 md:size-9';

export const TOP_BAR_ICON_STROKE_WIDTH = 1.2;
